var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.message)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.message))])]):_vm._e(),(!_vm.network.loading && !_vm.network.error && _vm.reportData)?_c('div',[_c('Report',_vm._b({},'Report',_vm.reportData,false))],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }